import React from "react";

import OneTrustPage from "../../OneTrustPage";
import "../style.scss";

export default function CookiesPolicy() {
  return (
    <OneTrustPage
      did="otnotice-df4c5eb0-7d3d-479b-a7ca-25372890f220"
      json="https://omnicom-privacy-cdn.my.onetrust.com/c0a325be-6f68-46be-a0de-e4a750890f7d/privacy-notices/df4c5eb0-7d3d-479b-a7ca-25372890f220.json"
    />
  );
}
